import React from 'react';
import AppSettingsContext from '../context.js';
import * as u from '../utils.js'
import {Element} from '../templates/elements.js';
import chroma from 'chroma-js';
/*---------------------------------------------*/

export default class LoadMoreButton extends Element {
	static contextType = AppSettingsContext;

	render() {
		let textColor = u.renderColor(this.context.get('style.button.text','#333'));
		let borderColor = u.renderColor(this.context.get('style.button.border.color',textColor));
		
		let borderWidth = this.context.get('style.button.border.width',1);
		let borderRadius = this.context.get('style.button.border.radius',2);

		let styles = {
			container: {
				...this.props.baseStyle,
				textAlign: 'center',
				paddingTop: 12,
				paddingBottom: 12
			},
			button: {
				border: `${borderWidth}px solid ${borderColor}`,
				color: textColor,
				background: 'transparent',
				borderRadius: borderRadius,
				lineHeight: 2.5,
				padding: '0 calc(1em + 2px)',
				cursor: 'pointer',

				fontSize: 16,
				fontWeight: 'bold',
				fontStyle: 'normal',
				...u.getFontStyle(this.context,'style.button.font')
			}
		};

		if (this.state.hover) {
			let shadowColor = chroma(borderColor).alpha(0.1)
			styles.button.boxShadow = `inset 0 100px ${shadowColor}`;
		}

		// font size mobile override?
		let buttonFontSize = this.context.get('style.button.fontSize');
		if (buttonFontSize)
			styles.button.fontSize = buttonFontSize;

		let buttonLabel = 
			this.context.get('layout.navigation.loadmore.button.text') || 
			this.context.default('layout.navigation.loadmore.button.text');
			
		return (
			<div style={styles.container}>
				<button style={styles.button} {...this.hoverEvents} onClick={this.props.onClick}>{buttonLabel}</button>
			</div>
		)
	}
}

/*---------------------------------------------*/
